import {useState} from "react";

export default function InlineRename({value, onSave, className = ""}) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(value);

    const save = async () => {
        const trimmed = draft.trim();
        if (trimmed && trimmed !== value) await onSave(trimmed);
        setEditing(false);
    };

    const cancel = () => { setDraft(value); setEditing(false); };

    if (editing) return (
        <form
            className="d-inline-flex align-items-center gap-1"
            onSubmit={e => { e.preventDefault(); save(); }}
            onClick={e => e.stopPropagation()}
        >
            <input
                className="form-control form-control-sm"
                style={{maxWidth: 220}}
                value={draft}
                onChange={e => setDraft(e.target.value)}
                onKeyDown={e => e.key === "Escape" && cancel()}
                autoFocus
            />
            <button type="submit" className="btn btn-sm btn-success p-1">
                <i className="bi bi-check" />
            </button>
            <button type="button" className="btn btn-sm btn-outline-secondary p-1" onClick={cancel}>
                <i className="bi bi-x" />
            </button>
        </form>
    );

    return (
        <span className={`d-inline-flex align-items-center gap-2 ${className}`}>
            <span>{value}</span>
            <button
                className="btn btn-sm p-0 border-0 text-muted"
                style={{lineHeight: 1, opacity: 0.5}}
                onClick={e => { e.preventDefault(); e.stopPropagation(); setDraft(value); setEditing(true); }}
                title="Rename"
            >
                <i className="bi bi-pencil" style={{fontSize: "0.7rem"}} />
            </button>
        </span>
    );
}
